import {
  TrackOlciFlowEventInterface,
  TrackOlciFlowParamsInterface,
  GlobalAnalyticsVariablesInterface
} from '../interfaces';
import {analyticsConstants} from '../../constants';
import {TelemetryGenericEnum} from '../../shared/enums';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackOlciStartEventCase = (
  payload: TrackOlciFlowParamsInterface,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackOlciFlowEventInterface => {
  const data = retrieveTrackOlciStartEventPayload(payload);
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveTrackOlciStartEventPayload = (
  payload: TrackOlciFlowParamsInterface,
): TrackOlciFlowEventInterface => ({
  eventType: TelemetryGenericEnum.INTERACTION_EVENT_TYPE,
  olciPassengerIds: payload.olciPassengerIds ?? TelemetryGenericEnum.EMPTY_VALUE,
  fluidVariable: analyticsConstants.FLOW_EVENTS.START_FLUID_VARIABLE,
  interaction: analyticsConstants.FLOW_EVENTS.START_INTERACTION,
  pageName: analyticsConstants.FLOW_EVENTS.START_PAGE_NAME,
})
